import { Channel } from 'types/masterData'
import { cx } from 'utils/cx'

import styles from './BodyContent.module.scss'
import text from 'fukku/styles/texts.module.scss'

const MAX_PRICES_TO_SHOW_MESSAGE = 3

type BodyContentProps = {
	numberOfPrices: number
	channel: Channel
	getLabel: (key: string, keys?: Record<string, string> | undefined) => string
}

export function BodyContent({
	numberOfPrices,
	channel,
	getLabel,
}: BodyContentProps) {
	const priceDescriptionLabel =
		channel === Channel.Shop
			? 'pdp.priceDescription.tooltip'
			: 'pdp.priceDescription.outlet.tooltip'

	return (
		<>
			<p className={cx(text.bodyS, styles.paragraph)}>
				{getLabel(priceDescriptionLabel)}
			</p>
			{channel === Channel.Outlet &&
				numberOfPrices > MAX_PRICES_TO_SHOW_MESSAGE && (
					<p className={cx(text.bodyS, styles.paragraph)}>
						{getLabel('pdp.previousPrice.outlet.tooltip')}
					</p>
				)}
		</>
	)
}
